import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="font-serif text-xl font-semibold mb-3">
              Todd <span className="text-accent-400">Sexton</span>
            </h3>
            <p className="text-gray-400 max-w-md mb-5 text-sm">
              Todd Sexton provides experienced fractional COO leadership to cemetery and 
              deathcare organizations seeking operational stability, revenue expansion, 
              and long-term asset strength.
            </p>
            <div className="space-y-2">
              <a href="tel:844-622-9007" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm">
                <Phone size={16} />
                <span>(844) 622-9007</span>
              </a>
              <a href="mailto:info@blackswan-consulting.com" className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors text-sm">
                <Mail size={16} />
                <span>Info@blackswan-consulting.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-medium text-sm mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['About', 'Services', 'Case Results', 'Contact', 'Cemetery Manager\'s Blog'].map((link) => (
                <li key={link}>
                  <Link
                    to={link === "Cemetery Manager's Blog" ? "https://blackswan-consulting.com/cemetery-managers-blog/" : `/${link.toLowerCase().replace(' ', '-')}`}
                    target={link === "Cemetery Manager's Blog" ? "_blank" : undefined}
                    rel={link === "Cemetery Manager's Blog" ? "noopener noreferrer" : undefined}
                    className="text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {link}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-medium text-sm mb-4">Services</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Fractional COO</li>
              <li>Revenue Diagnostics</li>
              <li>Exit & Transition Advisory</li>
              <li>Strategic Advisory</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-10 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3">
            <p className="text-gray-500 text-xs">
              © {new Date().getFullYear()} Todd Sexton. All rights reserved. a Division of Black Swan Consulting LLC
              <span className="mx-2">|</span>
              <a href="https://blackswan-consulting.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white transition-colors">Privacy Policy</a>
              <span className="mx-2">|</span>
              <a href="https://blackswan-consulting.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-white transition-colors">Terms of Service</a>
            </p>
            <p className="text-gray-500 text-xs">Fractional COO for Cemetery Operations</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
